import StorageInvoicePage from "./StorageInvoicePage";

export default StorageInvoicePage;